import { reactive } from 'vue';

import { ConsentI } from '@/support/interfaces';

type StateType = {
  tppsLoaded: boolean;
  tpps: ConsentI[];
  selectedTppId: string;
};

const state = reactive<StateType>({
  tppsLoaded: false,
  tpps: [],
  selectedTppId: '',
});

export default state;
